import { Box, BoxProps, Button, ButtonProps, Flex, FlexProps, HStack, ImageProps, StackProps, Text, TextProps, VStack } from "@chakra-ui/react";
import { Image } from "../../components";

export interface SnackItemsProps {
  name: string;
  description: string;
  price: number;
  image: string;
  idx: string;
  onAdd: (quantity: number) => void;
  quantity: number;
  snackItemsContainerProps?: BoxProps;
  imageBoxProps?: BoxProps;
  imageProps?: ImageProps;
  contentBoxProps?: BoxProps;
  contentVStackProps?: StackProps;
  nameProps?: TextProps;
  descriptionProps?: TextProps;
  priceAndQuantityHStackProps?: StackProps;
  priceTextProps?: TextProps;
  quantityFlexProps?: FlexProps;
  minusButtonProps?: ButtonProps;
  plusButtonProps?: ButtonProps;
  addButtonProps?: ButtonProps;
  quantityTextProps?: TextProps;
}

function SnackItems({
  name,
  description,
  price,
  image,
  onAdd,
  quantity,
  snackItemsContainerProps,
  imageBoxProps,
  imageProps,
  contentBoxProps,
  contentVStackProps,
  nameProps,
  descriptionProps,
  priceAndQuantityHStackProps,
  priceTextProps,
  quantityFlexProps,
  minusButtonProps,
  plusButtonProps,
  addButtonProps,
  quantityTextProps,
}: SnackItemsProps) {
  return (
    <Box
      bg="white"
      p={3}
      borderRadius="lg"
      border="1px"
      borderColor="gray.200"
      display="flex"
      flexDirection="column"
      gap={3}
      h="full"
      {...snackItemsContainerProps}
    >
      <Box
        w="full"
        aspectRatio={1}
        borderRadius="md"
        overflow="hidden"
        flexShrink={0}
        {...imageBoxProps}
      >
        <Image
          src={image}
          alt={`foodItem-${name}`}
          w="full"
          h="full"
          objectFit="cover"
          {...imageProps}
        />
      </Box>
      <Box
        flex="1"
        minW={0}
        overflowWrap="anywhere"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        {...contentBoxProps}
      >
        <VStack spacing={1} align="start" mb={2} {...contentVStackProps}>
          <Text
            fontWeight="600"
            // Tracks card width, not viewport: cards are widest at `sm` (3 columns, full width)
            // and narrow again from `md` (4+ columns, then the booking summary takes a third).
            fontSize={{ base: "sm", sm: "md", md: "sm" }}
            lineHeight="short"
            mb={0}
            pb={0}
            noOfLines={2}
            {...nameProps}
          >
            {name}
          </Text>
          <Text fontSize="xs" color="gray.600" fontWeight="400" noOfLines={2} {...descriptionProps}>
            {description}
          </Text>
        </VStack>
        <HStack
          justify="space-between"
          flexWrap="wrap"
          spacing={0}
          gap={2}
          w="full"
          {...priceAndQuantityHStackProps}
        >
          <Text fontWeight="600" whiteSpace="nowrap" {...priceTextProps}>Rs. {price}</Text>

          {quantity > 0 ? (
            <Flex gap={2} align="center" {...quantityFlexProps}>
              <Button
                size="sm"
                variant="outline"
                onClick={() => onAdd(quantity - 1)}
                {...minusButtonProps}
              >
                -
              </Button>
              <Text {...quantityTextProps}>{quantity}</Text>
              <Button
                size="sm"
                variant="outline"
                onClick={() => onAdd(quantity + 1)}
                {...plusButtonProps}
              >
                +
              </Button>
            </Flex>
          ) : (
            <Button
              size="sm"
              variant="outline"
              borderRadius="full"
              px={4}
              onClick={() => onAdd(1)}
              {...addButtonProps}
            >
              Add
            </Button>
          )}
        </HStack>
      </Box>
    </Box>
  );
}

export default SnackItems;
